// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1ii-J","visible-sm":"visible-sm___1D3zH","visible-md":"visible-md___33rZv","visible-lg":"visible-lg___fTzOI","row":"row___2lrAD","hidden-xs":"hidden-xs___1qmZL","hidden-sm":"hidden-sm___1_pkA","hidden-md":"hidden-md___1Ly48","hidden-lg":"hidden-lg___tErp8","about-banner":"about-banner___1YMqO center___2iqBf","page":"page___3sy2g","title":"title___dXF3H","answer":"answer___bZ1Gv","answer-info":"answer-info___FHkCO space-bottom-12___rGCm0 h3___5u0xZ","ays-logo":"ays-logo___1EYYh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.css
// module id = 936
// module chunks = 0